"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiscountCampaignType = void 0;
var DiscountCampaignType;
(function (DiscountCampaignType) {
    DiscountCampaignType["Regular"] = "Regular";
    DiscountCampaignType["VIP"] = "VIP";
    DiscountCampaignType["Influencer"] = "Influencer";
    DiscountCampaignType["DiscountOnStops"] = "DiscountOnStops";
    DiscountCampaignType["EmployeesAndFriends"] = "EmployeesAndFriends";
    DiscountCampaignType["TravelAgent"] = "TravelAgent";
    DiscountCampaignType["PostBookingDayTripDiscount"] = "PostBookingDayTripDiscount";
})(DiscountCampaignType || (exports.DiscountCampaignType = DiscountCampaignType = {}));
//# sourceMappingURL=discount-campaign-type.enum.js.map